import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import { BehaviorSubject, ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FormControl } from '@angular/forms';

import { GeneralLedgerAccountModel, GlAccountModel, GlPlanModeEnum } from '../../models';
import { GeneralLedgerApiService } from '../../services/general-ledger-api.service';

type GlAccountDropdownItem = GlAccountModel | GeneralLedgerAccountModel;

@Component({
  selector: 'rnpl-gl-account-dropdown',
  templateUrl: './gl-account-dropdown.component.html',
})
export class GlAccountDropdownComponent implements OnInit, OnChanges, OnDestroy {

  @Input() isOptional = false;
  @Input() isReadonly: boolean = false;
  @Input() glAccountsPlanMode: GlPlanModeEnum = null;
  @Input() validate: boolean = false;
  // @Input() bankRelated: boolean = false;
  @Input() title: string;
  @Input() value: number;
  @Input() control: FormControl = new FormControl();

  @Output() fieldUpdated: EventEmitter<number> = new EventEmitter<number>();

  readonly destroy$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  readonly glAccountsList$: BehaviorSubject<GlAccountDropdownItem[]> = new BehaviorSubject<GlAccountDropdownItem[]>([]);

  constructor(
    private readonly generalLedgerApiService: GeneralLedgerApiService,
  ) {
  }

  ngOnInit(): void {
    this.getGLAccounts();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.hasOwnProperty('isReadonly')) {
      if (this.control) {
        if (this.isReadonly) {
          this.control.disable({ emitEvent: false });
        } else {
          this.control.enable({ emitEvent: false });
        }
      }
    }
    if (changes && changes.hasOwnProperty('value')) {
      this.control.patchValue(this.value, { emitEvent: false });
    }
  }

  private getGLAccounts(): void {
    this.generalLedgerApiService.getAccounts('LIST', this.glAccountsPlanMode || GlPlanModeEnum.ACTIVE)
      .pipe(takeUntil(this.destroy$))
      .subscribe((accounts: GeneralLedgerAccountModel[]) => {
        this.glAccountsList$.next(accounts.filter((account: GeneralLedgerAccountModel) => account.type === 'ACCOUNT'));
      });
  }

  public updateField(accountId: number): void {
    this.fieldUpdated.emit(accountId);
  }

  public customSearchFn(term: string, item: GlAccountDropdownItem): boolean {
    term = term.toLocaleLowerCase();
    return item.name.toLocaleLowerCase().indexOf(term) > -1 || item.code.indexOf(term) > -1;
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

}
